/**
 * Colors for the paste flow: the admin's (themed) colors under the names the
 * paste components use. Quiet chrome, graphite text, "clay" for AI work that
 * hasn't been kept yet, and dashboard-lamp colors for status.
 */
import { S } from '~/app/ui/tokens';

export const T = {
  chrome: S.chrome,
  line: S.line,
  field: S.field,
  fieldLine: S.fieldLine,
  fg: S.fg,
  onFg: S.onFg,
  muted: S.muted,
  clay: S.clay,
  clayInk: S.clayInk,
  claySoft: S.claySoft,
  green: S.green,
  amber: S.amber,
  red: S.red,
  mono: S.mono
};

export const LEVEL_COLOR = { error: T.red, warn: T.amber, info: T.muted } as const;
